import { GoLock } from "react-icons/go";
import { BsMailbox2 } from "react-icons/bs";
import { FaArrowsRotate } from "react-icons/fa6";
import { OtherUserPosts } from "./OtherUserPosts";
import { OtherUserReposts } from "./OtherUserReposts";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ShareModal from "../../components/Modals/ShareModal";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { followUser } from "../../redux/ApiSlice/HomePageVideoSlice";
import { getAndCreateChatRoom } from "../../redux/ApiSlice/MessagesSlice";
import ProfileSection from "../../components/other-user/ProfileSection";
import SkeletonProfileSection from "../../components/skeleton/SkeletonProfileSection";
import { accountBlockUser, AccountProfilePosts, otherUserAccountPosts, otheruserAccountReport, OtherUserProfile, UserAccountFollow } from "../../redux/ApiSlice/AccountProfileSlice";
import AccountPage from "../AccountPage";
import { initial } from "lodash";
import VideoCard from "../../components/common/VideoCard";
import SkeletonVideoCard from "../../components/skeleton/SkeletonVideoCard";
import { getOtherUserReshare, resetLoadingMore } from "../../redux/ApiSlice/ResharedSlice";
import { IoIosArrowDown, IoMdArrowBack } from "react-icons/io";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { Button } from "@material-tailwind/react";
import toast from "react-hot-toast";
import { BeatLoader } from "react-spinners";
import { useOutsideClick } from "../../hooks/useOutsideClick";

export default function OtherUserAccount() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const location = useLocation();
    // Get feed type from navigation state (priority), URL params, or localStorage
    // const feedTypeFromState = location.state?.feedType;

    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { otherUser_profile, otherUser_posts, loadingMore, nextPage } = ProfileDetails || {};
    const { reSharedList, loading: resharedLoad, hasMore: resharedHasMore, error, nextPage: resharedNextPage } = useSelector((state) => state.resharedPosts);
    const filteredByResharedPosts = reSharedList?.map((item) => (item.original_post));
    const postsScrollRef = useRef(null);
    const [initalLoad, setInitalLoad] = useState(true);
    console.log(otherUser_profile, "otherUser_profile")
    const {
        posts = [],
        is_private = false,
        is_following = false,
        requested,
        follow_status,
        avatar,
        full_name,
        is_blocked,
    } = otherUser_profile || {};

    const [count, setCount] = useState("allPosts");
    const [openShare, setOpenShare] = useState(false);
    const [activeTab, setActiveTab] = useState("Account");
    const [activeTabState, setActiveTabState] = useState('posts');
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showBlockConfirm, setShowBlockConfirm] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);
    const [reportUser, setReportUser] = useState(false);
    const [reportSuccess, setReportSuccess] = useState(false);
    const [reason, setReason] = useState("");
    const [message, setMessage] = useState("");
    const [showReasonDropdown, setShowReasonDropdown] = useState(false);

    const userRef = useRef(null);
    const [openPopup, setOpenPopup] = useState(false);

    const ref = React.useRef(null);

    const handleFetch = useCallback(async () => {
        setInitalLoad(true);
        try {
            await dispatch(OtherUserProfile(id));

            setInitalLoad(false);
        } catch (error) {
            console.error("Error fetching other user profile:", error);
            setInitalLoad(false);
        } finally {
            setInitalLoad(false);
        }
    }, [id, dispatch]);

    const handleShare = () => setOpenShare(!openShare);

    const handleBlockCancel = () => {
        setShowBlockConfirm(false);
    }

    const handleBlockConfirm = async () => {
        try {
            const result = await dispatch(accountBlockUser(id));
            setShowBlockConfirm(false);
        } catch (error) {
            console.error("Error blocking user:", error);
            setShowBlockConfirm(false);
        }
    }
    const handleBlockUser = () => {
        setShowBlockConfirm(true);
        setOpenPopup(false);
    }


    const handleReportUser = async () => {
        setReportUser(!reportUser);
        setOpenPopup(false);
        setReportSuccess(false);
    }

    const handleCloseReportSuccess = () => {
        setReportSuccess(false);
        setReportUser(false);
        setReason("");
        setMessage("");
    }
    const handleReasonSelect = (selectedReason) => {
        setReason(selectedReason);
        setShowReasonDropdown(false);
    };


    const handleSubmitReportUser = async () => {
        const data = {
            reported_user_id: id,
            reason: reason,
            message: message
        }

        if (!id) {
            toast.error("User ID is required for reporting.");
            return;
        }

        if (!reason) {
            toast.error("Please select a reason for reporting the user.");
            return;
        }

        try {
            setReportLoading(true);
            const result = await dispatch(otheruserAccountReport({ data }));
            if (result.payload.non_field_errors) {
                toast.error(result.payload.non_field_errors[0]);
                setReportUser(false);
                setReportLoading(false);
            } else {
                setReportSuccess(true);
                setReportLoading(false);
            }
        } catch (error) {
            toast.error("Error reporting user:", error);
            setReportLoading(false);
        }
    }
    const handleFollowFun = useCallback(async () => {
        await dispatch(UserAccountFollow(id));
        await dispatch(followUser({ id }))
        if (activeTab === "posts" || activeTab === "allPosts") {
            await dispatch(OtherUserProfile(id));
        }
        await dispatch(OtherUserProfile(id));
    }, [dispatch, id]);

    const handleStartChat = async () => {
        try {
            const result = await dispatch(getAndCreateChatRoom(id)).unwrap();
            if (result.id) {
                navigate(`/message/${result.id}`);
            }
        } catch (error) {
            toast.error(error?.detail || "Unable to start chat.");
        }
    };

    useEffect(() => {
        handleFetch();

        const loadInitialData = async () => {
            dispatch(resetLoadingMore());

            if (id) {
                dispatch(otherUserAccountPosts({ id: id }));
                dispatch(
                    getOtherUserReshare({ userId: id, next: null })
                );
            }
        };
        if (!is_blocked) {
            loadInitialData();
        }

    }, [dispatch, id]);
    const handlePostsScroll = useCallback(() => {
        const container = postsScrollRef.current;
        if (!container || !id || !nextPage || loadingMore) {
            return;
        }

        const hasReachedBottom =
            container.scrollTop + container.clientHeight >= container.scrollHeight - 10;

        if (hasReachedBottom) {
            if (activeTabState === 'posts') {
                dispatch(
                    otherUserAccountPosts({
                        id: id,
                        nextUrl: nextPage,
                        isLoadMore: true,
                    })
                );
            } else {
                if (!resharedHasMore) return;
                dispatch(
                    getOtherUserReshare({
                        userId: id,
                        next: resharedNextPage,
                        isLoadMore: true,
                    })
                );
            }

        }
    }, [dispatch, loadingMore, nextPage, id, resharedNextPage, activeTabState]);

    const handleClickOutside = () => { setOpenPopup(false) };

    const refControl = useOutsideClick(userRef, handleClickOutside);

    useEffect(() => {
        // Don't set up listener during initial load
        if (initalLoad) return;

        const container = postsScrollRef.current;
        if (!container) {
            return;
        }
        container.addEventListener("scroll", handlePostsScroll);
        return () => {
            container.removeEventListener("scroll", handlePostsScroll);
        };
    }, [handlePostsScroll, initalLoad]);

    const handleBack = () => {
        if (count === "allPosts") {
            navigate(-1);
        } else {
            setCount("allPosts");
        }
    };

    const reportReasons = [
        "Harassment",
        "Inappropriate",
        "Bullying or targeted harrassment",
        "Hate speech",
        "Blackmail",
        "Sexual Harassment",
        "Impersonation/Fake account",
        "Graphic Violence/Gore",
        "Spam",
        "Drugs/Weapons",
        "Sexual content involving suspected minors",
        "Stalking or Intimidation",
        "Child safety concerns",
        "Self-harm or suicide content",
        "Violence or physical harm threats",
        "Dangerous acts & challenges",
        "Human exploitation/trafficking",
        "Scams/Fraud/Phishing",
        "Illegal Services/Solicitation",
        "IP Infringement",
        "Other"
    ];

    if (initalLoad) {
        return <SkeletonProfileSection />
    }

    return (
        <>
            <div
                ref={postsScrollRef}
                className={`h-full bg-white dark:bg-[#1E1D21] dark:text-white overflow-y-scroll  relative`}
            >
                <div className="flex items-center justify-between h-12 bg-[#BDE6FF] rounded-b-xl px-2 sticky top-0 z-50">
                    <div className="flex items-center gap-x-2">
                        <IoMdArrowBack
                            onClick={() => handleBack()}
                            className="text-[22px] text-black cursor-pointer"
                        />
                    </div>
                    <p className="text-[14px] font-semibold line-clamp-1 text-black">
                        {full_name}
                    </p>
                    {!is_blocked &&
                        <div className="relative">
                            <HiOutlineDotsVertical
                                onClick={() => setOpenPopup(!openPopup)}
                                className="text-[20px] text-black cursor-pointer"
                            />
                            {openPopup &&
                                <div ref={userRef} className="absolute top-[24px] md:top-[22px] right-2 md:right-0 bg-white dark:bg-[#333333] border-2 border-indigo-100 z-10 rounded-lg whitespace-nowrap shadow-lg overflow-hidden">
                                    <p
                                        onClick={() => handleBlockUser()}
                                        className="text-[16px] md:text-[12px] px-2 py-1 text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-800 border-b border-gray-400 dark:border-gray-800 cursor-pointer"
                                    >
                                        Block
                                    </p>
                                    <p
                                        onClick={() => handleReportUser()}
                                        className="text-[16px] md:text-[12px] px-2 py-1 text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-800 cursor-pointer"
                                    >
                                        Report
                                    </p>
                                </div>
                            }
                        </div>
                    }
                </div>

                <ProfileSection
                    userId={id}
                    setCount={setCount}
                    count={count}
                    handleFollowFun={handleFollowFun}
                    handleStartChat={handleStartChat}
                    setActiveTab={setActiveTab}
                    showProfileModal={showProfileModal}
                    setShowProfileModal={setShowProfileModal}
                />

                {(count === "Posted" || count === "allPosts") && ((is_private && is_following) || !is_private) && !otherUser_profile?.is_blocked && !requested && (
                    <div className=" bg-white dark:bg-[#1E1D21] flex items-center justify-center gap-x-2 mb-0.5 mx-2 z-10">
                        <div
                            onClick={() => setActiveTabState('posts')}
                            className={`flex justify-center items-center w-full py-1.5 cursor-pointer border-b-2 ${activeTabState === 'posts'
                                ? 'border-light-blue-400 dark:border-blue-500'
                                : 'border-transparent'
                                }`}
                        >
                            <BsMailbox2 className={`text-[15px] ${activeTabState === 'posts'
                                ? 'text-light-blue-400 dark:text-blue-500'
                                : 'text-black dark:text-white'
                                }`} />
                            <p className={`text-[10px] ml-2 mt-[1.5px] font-semibold whitespace-pre-line cursor-pointer ${activeTabState === 'posts'
                                ? 'text-light-blue-400 dark:text-blue-500'
                                : 'text-black dark:text-white'
                                }`}>
                                Posts
                            </p>
                        </div>
                        <div
                            onClick={() => setActiveTabState('reposts')}
                            className={`flex justify-center items-center w-full py-1.5 cursor-pointer border-b-2 ${activeTabState === 'reposts'
                                ? 'border-light-blue-400 dark:border-blue-500'
                                : 'border-transparent'
                                }`}
                        >
                            <FaArrowsRotate className={`text-[13px] ${activeTabState === 'reposts'
                                ? 'text-light-blue-400 dark:text-blue-500'
                                : 'text-black dark:text-white'
                                }`} />
                            <p className={`text-[10px] ml-2 mt-[0.5] font-semibold whitespace-pre-line cursor-pointer ${activeTabState === 'reposts'
                                ? 'text-light-blue-400 dark:text-blue-500'
                                : 'text-black dark:text-white'
                                }`}>
                                Reposts
                            </p>
                        </div>
                    </div>
                )}

                {!otherUser_profile?.is_blocked &&
                    <>
                        {((is_private && is_following && !requested) || (!is_private)) && (
                            <div className="p-0 mt-1 no-scrollbar w-full relative h-full">
                                <>
                                    {(count === "Posted" || count === "allPosts") && (
                                        <>
                                            {activeTabState === 'posts' && (
                                                <OtherUserPosts otherUser_posts={otherUser_posts} nextPage={nextPage} />
                                            )}
                                            {activeTabState === 'reposts' && (
                                                <OtherUserReposts userId={id} filteredByResharedPosts={filteredByResharedPosts} reSharedList={reSharedList} loading={resharedLoad} hasMore={resharedHasMore} error={error} />
                                            )}
                                        </>
                                    )}
                                </>
                            </div>
                        )}
                        {loadingMore && (
                            <div className="flex justify-center items-center py-4">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-white"></div>
                            </div>
                        )}
                    </>
                }

                {is_private && (follow_status === "not_following" || follow_status === "requested") && (
                    <div className="flex flex-col items-center justify-center h-64">
                        <GoLock className="text-gray-500 dark:text-gray-400 text-6xl mb-4" />
                        <div className="text-center">
                            <p className="text-gray-600 dark:text-gray-400 text-lg font-medium">
                                {otherUser_profile?.is_blocked ? "This account is blocked" : "This account is private"}
                            </p>
                            <p className="text-gray-500 dark:text-gray-500 text-sm mt-2">
                                {requested ? "Follow request sent" : "Follow this account to see their posts"}
                            </p>
                        </div>
                    </div>
                )}
            </div>

            <ShareModal
                openBottom={openShare}
                closeDrawerBottom={handleShare}
                userId={id}
            />

            {/* Profile Picture Modal */}
            {showProfileModal && (
                <div className="absolute h-full inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center" onClick={() => setShowProfileModal(false)}>
                    <div className="relative max-w-4xl max-h-[90vh] p-4">
                        <img
                            src={avatar}
                            alt={`${full_name}'s profile`}
                            onClick={(e) => e.stopPropagation()}
                            className="max-w-full max-h-full object-contain rounded-lg"
                        />
                    </div>
                </div>
            )}

            {/* Block User Confirmation Popup */}
            {showBlockConfirm && (
                <div className="absolute h-[82vh] inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                    <div className="bg-white h-auto py-4 dark:bg-[#333333] shadow-lg rounded-lg w-[300px] flex flex-col items-center justify-center">
                        <p className="text-[24px] font-bold text-black dark:text-white text-center mb-2">
                            Block {full_name}?
                        </p>
                        <p className="text-[12px] text-black px-4  dark:text-white text-center">
                            Are you sure you want to block {full_name}? They will not be able to send you messages,
                            find your profile, or see your posts and they will not be notified that you blocked them.
                        </p>
                        <div className="flex gap-2 mt-4">
                            <Button
                                onClick={handleBlockCancel}
                                size="sm"
                                className="bg-[#1b1b1b] dark:bg-gray-400 dark:text-black dark:hover:bg-gray-500 hover:bg-[#0f0f0f] text-white"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleBlockConfirm}
                                size="sm"
                                className="bg-red-900 hover:bg-red-600 text-white"
                            >
                                Block
                            </Button>
                        </div>
                    </div>
                </div>
            )}

            {/* Report User Modal */}
            {reportUser && (
                <div className="absolute h-full inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
                    <div className="bg-white h-auto py-2 dark:bg-[#333333] shadow-lg rounded-lg w-[300px] flex flex-col items-center justify-center">
                        {!reportSuccess ? (
                            <>
                                <p className="text-[24px] font-bold text-black dark:text-white text-center">
                                    Report {full_name}
                                </p>
                                <p className="text-[12px] text-black mb-2 dark:text-white text-center">
                                    Are you sure you want to report {full_name}?
                                </p>
                                <div className="px-2 w-full">
                                    <label htmlFor="report-reason" className="block text-[12px] mb-0.5 font-semibold text-black dark:text-white">
                                        Reason <span className="text-red-500">*</span>
                                    </label>
                                    <div className="relative custom-dropdown">
                                        <div
                                            onClick={() => setShowReasonDropdown(!showReasonDropdown)}
                                            className="w-full h-[35px] border border-gray-400 dark:border-gray-600 bg-white dark:bg-[#333333] rounded-lg p-1 text-[12px] focus:outline-none cursor-pointer flex items-center justify-between"
                                        >
                                            <span className={reason ? "text-black dark:text-white" : "text-gray-500"}>
                                                {reason || "Select a reason"}
                                            </span>
                                            <IoIosArrowDown className="text-gray-500" />
                                        </div>
                                        {showReasonDropdown && (
                                            <div className="absolute top-[36px] left-0 w-full bg-white dark:bg-[#333333] border border-gray-400 dark:border-gray-600 rounded-lg shadow-lg z-10 max-h-[125px] overflow-y-auto">
                                                {reportReasons.map((reasonOption, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => handleReasonSelect(reasonOption)}
                                                        className="px-2 py-1.5 text-[12px] text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer border-b border-gray-200 dark:border-gray-700 last:border-b-0"
                                                    >
                                                        {reasonOption}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="px-2 w-full mt-2">
                                    <label htmlFor="report-details" className="block text-[12px] mb-0.5 font-semibold text-black dark:text-white">
                                        Optional Details
                                    </label>
                                    <textarea
                                        rows={6}
                                        value={message}
                                        maxLength={200}
                                        id="report-details"
                                        placeholder="Type your report here..."
                                        onChange={(e) => setMessage(e.target.value)}
                                        className="w-full h-[50px] border border-gray-400 dark:border-gray-600 dark:bg-[#333333] dark:text-white rounded-lg p-1.5 text-[12px] focus:outline-none resize-none"
                                    />
                                </div>

                                <div className="flex gap-2 my-2">
                                    <Button
                                        onClick={handleReportUser}
                                        size="sm"
                                        className="bg-[#1b1b1b] dark:bg-gray-400 dark:text-black dark:hover:bg-gray-500 hover:bg-[#0f0f0f] text-white"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={handleSubmitReportUser}
                                        size="sm"
                                        className="border border-gray-400 dark:border-gray-800 bg-red-900 hover:bg-red-600 text-white"
                                    >
                                        {reportLoading ? <BeatLoader
                                            size={10}
                                            color={"#fff"}
                                            loading={reportLoading}
                                        /> : " Report"}
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className="text-[20px] font-bold text-black dark:text-white text-center mb-4">
                                    Report Submitted
                                </p>
                                <p className="text-[12px] text-black dark:text-white text-center px-4 mb-4 leading-relaxed">
                                    We have received your report and will review {full_name}'s account. If there is a violation of our Community Guidelines we will take action. Thank you!
                                </p>
                                <Button
                                    onClick={handleCloseReportSuccess}
                                    size="sm"
                                    className="bg-blue-500 hover:bg-blue-600 text-white"
                                >
                                    OK
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}